<template>
  <div class="wei-block bg-white in-expert-block mt-5 w-100">
    <div class="product-item ">
      <div class="item-title text-center py-4">师资团队</div>
      <div class="item-content">
        <div id="carouselExampleCaptions" class="wei-carousel pb-5 overflow-hidden carousel slide carousel-fade "
             style="position: relative">
          <ol class="carousel-indicators" v-if="teacherList && teacherList.length>0">
            <li data-target="#carouselExampleCaptions"
                data-slide-to="0" class="border-0 active" >
            </li>
            <li data-target="#carouselExampleCaptions" v-for="index in teacherList.length-1" :key="'v-'+index"
                :data-slide-to="index+1" class="border-0">
            </li>
          </ol>
          <div class="carousel-inner wei-carousel-width">
            <div class="carousel-item wei-carousel-item"
                 v-for="(v,i) in lastTwoList" :key="'k-'+v.id" :data-role="i+length">
              <div @click="goPage(v)" class="wei-item wei-a-item position-relative d-block">
                <div class=" d-flex justify-content-center  zj-item-title">
                  <div class="wei-img-logo position-absolute"
                       :style="{'background-image':'url('+uploadresUrl+v.imageUrl+')'}">
                  </div>
                  <div class="text-center">
                    <p class="zj_title mb-0">{{v.title}}</p>
                  </div>
                </div>
                <div class="wei-item-desc">
                  {{v.summary}}
                </div>
              </div>
            </div>

            <div class="carousel-item wei-carousel-item"
                 v-for="(item,index) in teacherList" :key="item.id" :data-role="index">
              <div @click="goPage(item)"
                           class="wei-item wei-a-item position-relative d-block">
                <div class=" d-flex justify-content-center  zj-item-title">
                  <div class="wei-img-logo position-absolute"
                       :style="{'background-image':'url('+uploadresUrl+item.imageUrl+')'}">
                  </div>
                  <div class="text-center">
                    <p class="zj_title mb-0">{{item.title}}</p>
                  </div>
                </div>
                <div class="wei-item-desc">
                  {{item.summary}}
                </div>
              </div>
            </div>

            <div class="carousel-item wei-carousel-item"
                 v-for="(v,i) in prevTwoList" :key="'key-'+v.id" :data-role="i">
              <div @click="goPage(v)"
                           class="wei-item wei-a-item position-relative d-block">
                <div class=" d-flex justify-content-center  zj-item-title">
                  <div class="wei-img-logo position-absolute"
                       :style="{'background-image':'url('+uploadresUrl+v.imageUrl+')'}">

                  </div>
                  <div class="text-center">
                    <p class="zj_title mb-0">{{v.title}}</p>
                  </div>
                </div>
                <div class="wei-item-desc">
                  {{v.summary}}
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue';
  import {Card} from 'vant';
  import $ from 'jquery'

  Vue.use(Card);
  import {Swipe, SwipeItem} from 'vant';
  import {mapState} from "vuex";


  Vue.use(Swipe);
  Vue.use(SwipeItem);


  export default {
    name: "teacherComponent",
    data() {
      return {
        screen_width: 0,
        prevTwoList: [],
        lastTwoList: [],
        length: 0,
        teacherList: []
      }
    },
    props: [
      'LecturersList'
    ],
    computed: {
      ...mapState({
        uploadresUrl: state => state.uploadresUrl,
        ContentTypeEnum: state => state.ContentTypeEnum
      })
    },
    mounted() {

    },
    created() {
      if(this.LecturersList) {
        this.teacherList =  this.LecturersList;
        this.lastTwoList = this.teacherList.slice(this.teacherList.length - 2);
        this.prevTwoList = this.teacherList.slice(0, 2);
        this.length = this.teacherList.length - 2;
        setTimeout(() => {
          this.scollFunc();
        }, 20)
      }

    },
    watch: {
    },
    methods: {
      goPage(item) {
        if (item.contentType === this.ContentTypeEnum.PROJECT.value
          || item.contentType === this.ContentTypeEnum.COURSE.value) {
          this.$router.push('/'+item.contentType+'/'+item.content);
        }
        if (item.contentType === this.ContentTypeEnum.USER.value) {
          this.$router.push('/lecturer/'+item.content);
        }
        if (item.contentType === this.ContentTypeEnum.NEWS.value) {
          this.$router.push('/news-detail/'+item.id);
        }
        if (item.contentType === this.ContentTypeEnum.LINK.value) {
          window.open(item.linkUrl);
        }

      },
      scollFunc() {
        var headerHeight = $('.app-header').height();
        var dropHeight = window.screen.height - headerHeight;
        $('.app-dropdown-menu').css('height', dropHeight + 'px');
        var num = 1;
        var innnerLen = $('.wei-carousel-width').children('.carousel-item').length - 4;
        //获取屏幕的宽度
        var screen_width = $('body').width();
        //滑动效果
        var touch, startX;
        var sta = false;
        //item宽
        let w = Math.floor(screen_width * 0.74);

        //左偏移量
        let wl = -(w * 1.5 - screen_width / 2);
        //item固定宽度
        $('.wei-carousel-item').css({
          flex: `0 0 ${w}px`,
          display: 'block'
        });
        //wl的基础上在向左偏移一个item的宽，防止只有一个item的情况
        let ll = wl - w;
        //把左边的两个左偏移，初始化页面将第一个在中间位置显示，none是取消动画效果
        $('.wei-carousel-width').css({
          'transition-property': 'none',
          'transform': 'translateX(' + ll + 'px)'
        });

        $('.wei-carousel-item').on('touchstart', function (e) {
          touch = e.originalEvent;
          startX = touch.changedTouches[0].pageX;
          $(this).on('touchmove', function (e) {
            e.stopPropagation();

            touch = e.originalEvent.touches[0] || e.originalEvent.changedTouches[0];
            if (touch.pageX - startX > 20) {  //手向右滑动
              if (sta) {
                return false;
              }
              sta = true;
              $(this).off('touchmove');
              //右滑偏移量少一个item宽
              ll += w;
              //all有动画效果
              $('.wei-carousel-width').css({
                'transition-property': 'all',
                'transform': 'translateX(' + ll + 'px)'
              });

              setTimeout(() => {
                sta = false;
                //如果左边只有一个item的时候
                if (ll > wl - 1) {
                  //wl左偏移量+元素个数*item宽
                  ll = wl - w * innnerLen;
                  //取消动画，并往左偏移6个item
                  $('.wei-carousel-width').css({
                    'transition-property': 'none',
                    'transform': 'translateX(' + ll + 'px)'
                  });
                }
                num = Math.floor($('.wei-carousel-width').css('transform').split(',')[4] / -w) - 1;
                $(this).parents('.wei-carousel').find('.carousel-indicators').find('li').eq(num).addClass('active').siblings().removeClass('active');

              }, 500);

            } else if (touch.pageX - startX < -20) {//手向左滑动
              if (sta) {
                return false;
              }
              sta = true;

              $(this).off('touchmove');
              //左滑偏移量增加一个item宽
              ll -= w;
              //添加动画效果
              $('.wei-carousel-width').css({
                'transition-property': 'all',
                'transform': 'translateX(' + ll + 'px)'
              });


              setTimeout(() => {
                sta = false;
                //如果滑倒倒数第二元素
                if (ll < (wl - w * innnerLen - 1)) {
                  //取消动画，并回到初始位置
                  ll = wl - w;
                  $('.wei-carousel-width').css({
                    'transition-property': 'none',
                    'transform': 'translateX(' + ll + 'px)'
                  });
                }
                num = Math.floor($('.wei-carousel-width').css('transform').split(',')[4] / -w) - 1;
                $(this).parents('.wei-carousel').find('.carousel-indicators').find('li').eq(num).addClass('active').siblings().removeClass('active');
              }, 500);

            }

          });
        });

        $('.wei-carousel-item').on('touchend', function (e) {
          $(this).off('touchmove');
        });


      }
    }
  }
</script>

<style scoped>
  .wei-block .van-swipe {
    padding-top: 3rem;
    padding-bottom: 2rem;
  }
</style>
